import * as React from "react";
import styled, { css } from "styled-components";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import WidgetDetailsContext from "report/report-creation/WidgetDetailsContext";
import { widgetTitle } from "report/report-render-page/ReportWidgets";
import { reportWidgetHeaderId } from "report/Constants";
import WidgetTitle from "report/common/WidgetTitle";
const Container = styled.div`
  margin-top: 40px;
  margin-bottom: 200px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const TocLi = styled.li(
  ({ theme }) => css`
    &:not(:last-child) {
      margin-bottom: 6px;
    }

    a {
      width: 100%;
      text-decoration: none;
      color: ${theme.colors.text.primary};
      display: block;
    }
  `
);
const TocHeader = styled.h3(
  ({ theme }) => css`
    color: ${theme.colors.text.primary};
  `
);
const Toc = ({ widgets, handleTocClick = void 0 }) => {
  const { t } = useTranslation("enterprise_report");
  const { widgets: widgetDetails, isLoading } = useContext(WidgetDetailsContext);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(TocHeader, { className: "has-bm" }, t("toc.title")), /* @__PURE__ */ React.createElement("ol", null, widgets.map((widget) => {
    const completeWidget = widgetDetails[widget.widgetId];
    return /* @__PURE__ */ React.createElement(TocLi, null, /* @__PURE__ */ React.createElement("a", { href: `#${reportWidgetHeaderId(widget.dashboardId, widget.widgetId)}`, onClick: handleTocClick }, /* @__PURE__ */ React.createElement(
      WidgetTitle,
      {
        title: widgetTitle(widget, completeWidget),
        isLoading,
        detailsAreAvailable: !isLoading && !!completeWidget
      }
    )));
  }))));
};
export default Toc;
